import { render, staticRenderFns } from "./MpPaint.vue?vue&type=template&id=806603e6&scoped=true&"
import script from "./MpPaint.vue?vue&type=script&lang=js&"
export * from "./MpPaint.vue?vue&type=script&lang=js&"
import style1 from "./MpPaint.vue?vue&type=style&index=1&id=806603e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806603e6",
  null
  
)

export default component.exports